import { defineMessages } from 'react-intl';

export default defineMessages({
    itemNumber: {
        id: 'ml.quoteandbind.valuableItemsSpecified.itemNumber',
        defaultMessage: 'Item Number'
    },
    itemType: {
        id: 'ml.quoteandbind.valuableItemsSpecified.itemType',
        defaultMessage: 'Item Type'
    },
    deductible: {
        id: 'ml.quoteandbind.valuableItemsSpecified.deductible',
        defaultMessage: 'Deductible'
    },
    appraisalDate: {
        id: 'ml.quoteandbind.valuableItemsSpecified.appraisalDate',
        defaultMessage: 'Appraisal Date'
    },
    itemValue: {
        id: 'ml.quoteandbind.valuableItemsSpecified.itemValue',
        defaultMessage: 'Value'
    },
    jewelryType: {
        id: 'ml.quoteandbind.valuableItemsSpecified.jewelryType',
        defaultMessage: 'Jewelry Type'
    },
    description: {
        id: 'ml.quoteandbind.valuableItemsSpecified.description',
        defaultMessage: 'Description'
    },
    valuationType: {
        id: 'ml.quoteandbind.valuableItemsSpecified.valuationType',
        defaultMessage: 'Valuation Type'
    },
    gemPrint: {
        id: 'ml.quoteandbind.valuableItemsSpecified.gemPrint',
        defaultMessage: 'Gem Print'
    },
    collectibleItemType: {
        id: 'ml.quoteandbind.valuableItemsSpecified.collectibleItemType',
        defaultMessage: 'Collectible Item Type'
    },
    fineArtType: {
        id: 'ml.quoteandbind.valuableItemsSpecified.fineArtType',
        defaultMessage: 'Fine Art Type'
    },
    breakage: {
        id: 'ml.quoteandbind.valuableItemsSpecified.breakage',
        defaultMessage: 'Breakage'
    },
    brand: {
        id: 'ml.quoteandbind.valuableItemsSpecified.brand',
        defaultMessage: 'Brand'
    },
    model: {
        id: 'ml.quoteandbind.valuableItemsSpecified.model',
        defaultMessage: 'Model'
    },
    serialNumber: {
        id: 'ml.quoteandbind.valuableItemsSpecified.serialNumber',
        defaultMessage: 'Serial Number'
    },
    modelYear: {
        id: 'ml.quoteandbind.valuableItemsSpecified.modelYear',
        defaultMessage: 'Model Year'
    },
    luxuryType: {
        id: 'ml.quoteandbind.valuableItemsSpecified.luxuryType',
        defaultMessage: 'Luxury Item Type'
    },
    yearOfManufacture: {
        id: 'ml.quoteandbind.valuableItemsSpecified.yearOfManufacture',
        defaultMessage: 'Year Of Manufacture'
    },
    tablewareType: {
        id: 'ml.quoteandbind.valuableItemsSpecified.tablewareType',
        defaultMessage: 'Tableware Type'
    },
    miscellaneousItems: {
        id: 'ml.quoteandbind.valuableItemsSpecified.miscellaneousItems',
        defaultMessage: 'Miscellaneous Items'
    },
    miscellaneousItemsAmount: {
        id: 'ml.quoteandbind.valuableItemsSpecified.miscellaneousItemsAmount',
        defaultMessage: 'Miscellaneous Items Amount'
    },
    professionalUse: {
        id: 'ml.quoteandbind.valuableItemsSpecified.professionalUse',
        defaultMessage: 'Professional Use'
    },
    action: {
        id: 'ml.quoteandbind.valuableItemsSpecified.action',
        defaultMessage: 'Action'
    },
    modalTitle: {
        id: 'ml.quoteandbind.valuableItemsSpecified.modalTitle',
        defaultMessage: 'Add Valuable Items - Specified'
    },
    addBtn: {
        id: 'ml.quoteandbind.valuableItemsSpecified.addBtn',
        defaultMessage: 'Add'
    },
    edit: {
        id: 'ml.quoteandbind.valuableItemsSpecified.edit',
        defaultMessage: 'Edit'
    },
    remove: {
        id: 'ml.quoteandbind.valuableItemsSpecified.remove',
        defaultMessage: 'Remove'
    },
    continueBtn: {
        id: 'ml.quoteandbind.valuableItemsSpecified.continueBtn',
        defaultMessage: 'Continue'
    },
});
